import { useRouter } from 'next/router'
import Container from '../../components/container';
import fetch from "isomorphic-fetch";
import config from "../../config.json";
import UnitMinimum from "../../components/unit-minimum";
import Masonry from "react-masonry-css";
import Pagination from "../../components/pagination";
import Whatsapp from "../../components/whatsapp";
import {normalize} from "normalize-diacritics";
import Static from "../../config-static.json";

const Category = ({data, menu})=>{
    const router = useRouter()
    const { asPath } = useRouter();
    const getItems = () => {
        return data.data.map(i=>{
            return <UnitMinimum key={i.id_producto} data={i}/>
        });
    };
    const pagePrint = (data?.pagination?.page > 1) ? `Página ${data.pagination.page},` : '';
    const title = (data?.detail?.title) ? `${data.detail.title}, ${pagePrint}, Envio de arreglos florales, Florería Detalles y Caprichos` : 'Florería Detalles y Caprichos';
    const meta = <>
        <link rel="canonical" href={`${Static.domain}${asPath}`}/>
        <meta name="publisher" content={Static.seo.publisher}/>
        <meta name="keywords" content={Static.seo.keywords}/>
        <meta property="og:description" content={Static.seo.description}/>
        <meta name="description" content={Static.seo.description}/>
        <meta name="robots" content="index, follow"/>
    </>;
    return (
        <>
            <Container title={title} menu={menu} meta={meta} noNewsletter={true} hiddenMobile={true}>
                <div className="dycIndice marginBottom">
                    <h1 className="dycIndiceTitle title marginBottom">{data.detail.title}</h1>
                    { (data.detail.description && data.pagination?.page === 1) && <div className="dycIndiceDescription" dangerouslySetInnerHTML={{__html: data.detail.description}}/>}
                </div>
                <Masonry
                    breakpointCols={{
                        default: 3,
                        1200: 3,
                        942: 2,
                        622: 1
                    }}
                    className="my-masonry-grid marginBottom"
                    columnClassName="my-masonry-grid_column">
                    {getItems()}
                </Masonry>
                <Pagination total={data.pagination.pages}
                            page={data.pagination.page}
                            path={`/${router.query.city}/${router.query.id}?pagina=`}
                            maxpages={data.pagination.pages}
                />
            </Container>
            <Whatsapp/>
        </>
    );
};

export async function getServerSideProps({query}){
    const isOrderedList = (Static.isListsOrder) ? '&order=position' : '';
    const page = (query.pagina) ? query.pagina : 1;
    const ID = await normalize(query.id.replace(/´/g,''));
    const res = await fetch(`${config.api.uri}/v1/product/price/${query.city}/category/${ID}?apikey=${config.api.apikey}&page=${page}&perpage=${config.pagination.perpage}${isOrderedList}`);
    const resJSON = await res.json();
    const resMenu = await fetch(`${config.api.uri}/v1/cat/menu/1?apikey=${config.api.apikey}`);
    const resJSONMenu = await resMenu.json();
    if(resJSON?.data?.length){
        return {
            props: {
                data: resJSON,
                menu: resJSONMenu
            }
        }
    }else{
        const product =  await fetch(`${config.api.uri}/v1/product/${ID.split('-').pop()}?apikey=${config.api.apikey}&partner=1`);
        const productJSON = await product.json();
        if(productJSON?.id_producto){
            return {
                redirect: {
                    permanent: true,
                    destination: `/producto/${productJSON.uri}`
                }
            }
        }else{
            return{
                notFound: true
            }
        }

    }
}

export default Category;
